import {Directive, ElementRef, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {DisabilityType} from './disabilityType';
import {DisabilityTypesService} from './disability-types.service';
import {Results} from '../../core/results';

declare var $: any;

@Directive({
  selector: '[appDisabilityType]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DisabilityTypeDirective),
    multi: true
  }]
})
export class DisabilityTypeDirective implements ControlValueAccessor, OnInit {

  @Input() private disabilityType: DisabilityType;
  @Input() private disabled = false;
  select2: any;

  constructor(private el: ElementRef, private service: DisabilityTypesService) {
  }

  ngOnInit(): void {
    const that = this;
    this.select2 = $(this.el.nativeElement).select2({
      width: '100%',
      placeholder: 'Disability Type',
      allowClear: true,
      ajax: {
        transport: function(params, success, failure) {
          that.service.search(1, 100, 'ASC', 'id', params.data.term).subscribe((ret: Results<DisabilityType>) => {
            success(ret);
          });
        },
        dataType: 'json',
        type: 'GET',
        processResults: function(data) {
          const arr = [];
          data.content.forEach(function(obj) {
            arr.push({
              id: JSON.stringify(obj),
              text: obj.name
            });
          });
          return { results: arr };
        }
      }
    });

    $(this.el.nativeElement).on('select2:select', function(e) {
      that.disabilityType = JSON.parse(e.params.data.id);
      that.propagateChange(that.disabilityType);
    });

    $(this.el.nativeElement).on('select2:unselect', function(e) {
      that.disabilityType = null;
      that.propagateChange(that.disabilityType);
    });
  }

  onTouched = () => {};

  propagateChange = (_: any) => {};

  writeValue(disabilityType: DisabilityType): void {
    this.disabilityType = disabilityType;
    this.propagateChange(this.disabilityType);
    const that = this;
    if (this.disabilityType !== undefined && this.disabilityType !== null) {
      const option = new Option(disabilityType.name, JSON.stringify(disabilityType), true, true);
      that.select2.append(option);
      that.select2.trigger('change');
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  get value(): any {
    return this.disabilityType;
  }

  set value(v: any) {
    if (v !== this.disabilityType) {
      this.disabilityType = v;
      this.propagateChange(v);
    }
  }
}
